import { endpoint } from '../decorators/endpoint.decorator';
import { BaseViewModel } from './base-view-model';

@endpoint('reviewcomment')
export class ReviewCommentViewModel extends BaseViewModel {
  public ReviewId: number = 0;
  public Comment: string = '';
}
